const FONT_STACKS = {
  Poppins: "'Poppins', sans-serif",
  Inter: "'Inter', sans-serif",
  Roboto: "'Roboto', sans-serif",
  "Open Sans": "'Open Sans', sans-serif",
  "System UI": "system-ui, -apple-system, sans-serif",
  Arial: "Arial, sans-serif",
  Georgia: "Georgia, serif",
};

export const FONT_OPTIONS = Object.keys(FONT_STACKS);

export const TYPO_GROUPS = [
  { key: "headings", label: "Headings / Titles" },
  { key: "body", label: "Body / Metadata" },
  { key: "buttons", label: "Buttons" },
  { key: "badges", label: "Badges" },
  { key: "nav", label: "Navigation / Menu" },
];

export const DEFAULT_TYPOGRAPHY = {
  headings: { family: "Poppins", weight: "600" },
  body: { family: "Poppins", weight: "400" },
  buttons: { family: "Poppins", weight: "500" },
  badges: { family: "Poppins", weight: "600" },
  nav: { family: "Poppins", weight: "500" },
};

const SELECTORS = {
  headings: "h1, h2, h3",
  body: "body",
  buttons: "button, [role='button']",
  badges: "[data-slot='badge'], span.rounded-full",
  nav: "nav, [role='menuitem']",
};

const CLASS = { headings: "tm-heading", body: "tm-body", buttons: "tm-btn", badges: "tm-badge", nav: "tm-nav" };

const safeSize = (v) => {
  const n = parseInt(v, 10);
  return Number.isFinite(n) && n >= 8 && n <= 48 ? `${n}px` : null;
};
const safeColor = (v) => (/^#[0-9a-fA-F]{3,8}$/.test(v || "") ? v : null);

export function buildTypographyCss(typo) {
  const t = typo || {};
  let css = "";
  for (const g of TYPO_GROUPS) {
    const c = { ...(DEFAULT_TYPOGRAPHY[g.key] || {}), ...(t[g.key] || {}) };
    const fam = FONT_STACKS[c.family] || FONT_STACKS.Poppins;
    const size = safeSize(c.size);
    const color = safeColor(c.color);
    css += `${SELECTORS[g.key]} { font-family: ${fam}; font-weight: ${c.weight || "400"} }\n`;
    css += `.${CLASS[g.key]} { font-family: ${fam} !important; font-weight: ${c.weight || "400"} !important`;
    if (size) css += `; font-size: ${size} !important`;
    if (color) css += `; color: ${color} !important`;
    css += " }\n";
  }
  return css;
}

export function applyTypography(typo) {
  if (typeof document === "undefined") return;
  let el = document.getElementById("tm-typography");
  if (!el) {
    el = document.createElement("style");
    el.id = "tm-typography";
    document.head.appendChild(el);
  }
  el.textContent = buildTypographyCss(typo);
}
